import { Comments } from "../../../../features/comments/components/comments/comments.component";
import { useSelector } from "react-redux";
import {
  selectExecutionBriefId,
  selectExecutionResourceType,
} from "../../../../redux/selectors/executionBriefs";
import { TResourceType } from "../../../../types/resources/resources.types";
import { HiddenHeading } from "../../../pages.styles";

export interface ExecutionBriefCommentsTabProps {
  pageTitle?: string;
}

export const ExecutionBriefCommentsTab = (props: ExecutionBriefCommentsTabProps) => {
  const modelId = useSelector(selectExecutionBriefId);
  const modelName = useSelector(selectExecutionResourceType) as TResourceType;

  return (
    <>
      <HiddenHeading>{props.pageTitle}</HiddenHeading>
      <Comments modelId={modelId} modelName={modelName} />
    </>
  );
};
